import { CoalitionModel } from './CoalitionModel';
import { CreatorEnum } from './GroupModel';
import { LocationModel } from './LocationModel';

export interface CommunityModel {
  active: boolean;
  communityId: string;
  limits: CommunityLimits;
  emailLimit?: string;
  creatorId: string;
  creationDate: string;
  university?: string;
  name: string;
  desc: string;
  imageUrl: string;
  coalitions?: CoalitionModel[];
  public: boolean;
  premium: boolean;
  type?: CreatorEnum;
  limit_sex?: string;
  location?: LocationModel;
  publicAvailable?: boolean;
  radius?: number;
  joinDate?: string;
  categories?: CategoryEnum[];
}

export enum CommunityLimits {
  ID_VERIFIED = 'ID_VERIFIED',
  EMAIL_VERIFIED = 'EMAIL_VERIFIED',
  NONE = 'NONE',
}

export enum CategoryEnum {
  RUNNING = 'RUNNING',
  WALKING = 'WALKING',
  HIKING = 'HIKING',
  HANGOUT = 'HANGOUT',
  LOCAL_COMMUNITY = 'LOCAL_COMMUNITY',
  NIGHTLIFE = 'NIGHTLIFE',
  OUTDOOR_FITNESS = 'OUTDOOR_FITNESS',
  BIKING = 'BIKING',
  PARENT_MEETUPS = 'PARENT_MEETUPS',
  BOOK_CLUBS = 'BOOK_CLUBS',
  CRAFTING_HOBBIES = 'CRAFTING_HOBBIES',
  YOGA_MEDITATION = 'YOGA_MEDITATION',
  PET_PLAYDATES = 'PET_PLAYDATES',
  ADVENTURE_TRAVEL = 'ADVENTURE_TRAVEL',
  TECH_GAMING = 'TECH_GAMING',
  VOLUNTEER = 'VOLUNTEER',
  CULTURAL_EVENTS = 'CULTURAL_EVENTS',
  LEARNING_SKILLS = 'LEARNING_SKILLS',
  NETWORKING = 'NETWORKING',
  ENTREPRENEURSHIP = 'ENTREPRENEURSHIP',
}
